const configData = document.appSettings;

export const backendAddress = (url) => {
    var address = process.env.NODE_ENV !== "production"
        ? configData.URL_DEV // localhost
        : configData.URL_PROD; // server test
    if (url == null) {
        url = "";
    }
    return address + url;
}


export const captchaKey = () => {
    return configData.CAPTCHA_KEY;
};

export const captchaV2Key = () => {
    return configData.CAPTCHA_V2_KEY;
}

export const hCaptchaKey = () => {
    return configData.HCAPTCHA_KEY;
}

export const getCompanyNameFromConfig = () => {
    return configData.COMPANY_NAME;
}
export const logErrors = () => {
    return configData.LOG_ERRORS;
}